import { render, staticRenderFns } from "./PaginaImportaTracciatiContabilita.vue?vue&type=template&id=58f8a031"
import script from "./PaginaImportaTracciatiContabilita.vue?vue&type=script&lang=js"
export * from "./PaginaImportaTracciatiContabilita.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportaTracciatiContabilita.vue?vue&type=style&index=0&id=58f8a031&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports